import React from 'react'

const PizzaIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="pizzaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 180, 60, 1)" />
          <stop offset="50%" stopColor="rgba(255, 150, 50, 1)" />
          <stop offset="100%" stopColor="rgba(255, 120, 40, 1)" />
        </linearGradient>
        <linearGradient id="cheeseGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 230, 100, 1)" />
          <stop offset="100%" stopColor="rgba(255, 200, 80, 1)" />
        </linearGradient>
        <filter id="pizzaGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Pizza circle base */}
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="url(#pizzaGradient)"
        filter="url(#pizzaGlow)"
      />
      
      {/* Crust edge - darker */}
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="rgba(200, 100, 30, 0.8)"
        strokeWidth="1.5"
      />
      
      {/* Inner cheese layer */}
      <circle
        cx="12"
        cy="12"
        r="8"
        fill="url(#cheeseGradient)"
        opacity="0.6"
      />
      
      {/* Pepperoni slices */}
      <circle cx="9" cy="8" r="1.8" fill="rgba(180, 40, 40, 1)" />
      <circle cx="15" cy="9" r="1.8" fill="rgba(180, 40, 40, 1)" />
      <circle cx="8" cy="13" r="1.8" fill="rgba(180, 40, 40, 1)" />
      <circle cx="14" cy="14" r="1.8" fill="rgba(180, 40, 40, 1)" />
      <circle cx="11" cy="15" r="1.5" fill="rgba(180, 40, 40, 1)" />
      
      {/* Pepperoni highlights */}
      <circle cx="9.5" cy="7.5" r="0.5" fill="rgba(220, 80, 80, 0.8)" />
      <circle cx="15.5" cy="8.5" r="0.5" fill="rgba(220, 80, 80, 0.8)" />
      <circle cx="8.5" cy="12.5" r="0.5" fill="rgba(220, 80, 80, 0.8)" />
      
      {/* Basil leaves (green) */}
      <ellipse cx="12" cy="10" rx="1.2" ry="0.8" fill="rgba(80, 180, 80, 0.9)" transform="rotate(20 12 10)" />
      <ellipse cx="16" cy="12" rx="1" ry="0.7" fill="rgba(80, 180, 80, 0.9)" transform="rotate(-15 16 12)" />
      
      {/* Melted cheese strings */}
      <path
        d="M7 15 Q6 17 5 18"
        stroke="rgba(255, 230, 150, 0.7)"
        strokeWidth="1.2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M17 15 Q18 17 19 18"
        stroke="rgba(255, 230, 150, 0.7)"
        strokeWidth="1.2"
        fill="none"
        strokeLinecap="round"
      />
      
      {/* Pizza slice line dividers */}
      <line x1="12" y1="12" x2="12" y2="2" stroke="rgba(200, 100, 30, 0.3)" strokeWidth="1" />
      <line x1="12" y1="12" x2="20" y2="16" stroke="rgba(200, 100, 30, 0.3)" strokeWidth="1" />
      <line x1="12" y1="12" x2="4" y2="16" stroke="rgba(200, 100, 30, 0.3)" strokeWidth="1" />
    </svg>
  )
}

export default PizzaIcon
